export default "__VITE_ASSET__xXlXB4ej__"